import { createEntityAdapter } from '@reduxjs/toolkit';

const zonesAdapter = createEntityAdapter();

export default zonesAdapter;
